import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import codeFormater from './code_formater.js'
import translate from 'toxilibs/translate.js'

SyntaxHighlighter.defaults.light         = true
SyntaxHighlighter.defaults['tab-size']   = 4
SyntaxHighlighter.defaults['quick-code'] = false


globalEventBus.on('goal code found', render)

globalEventBus.on('ui resized', resize)



let $sizeSetter
let $targetContainer

let currentCode

function render (codeFunction) {
    $('#sourceCode').remove()

    let $container = $('<div id="sourceCode"></div>')
    $('#main').append($container)

    currentCode = renderCode($container, codeFunction)
    $targetContainer = $('#sourceCode .syntaxhighlighter')

    resize()
}


let circle = '<i class="custom_icon icon-circle">&#xf111;</i>'

function renderCode ($container, codeFunction) {
    $sizeSetter = $('#sizeSetter')
    let formattedCode = codeFormater.format(codeFunction)

    let codeForHighlighter = codeFormater.convertColorConditionsForHighlighter(formattedCode)
    let $temporaryContentForHighlighter = $('<pre class="brush: js"></pre>')
    $temporaryContentForHighlighter.html(codeForHighlighter)
    $container.append($temporaryContentForHighlighter)

    SyntaxHighlighter.highlight()

    $container.find('code.js').each(function () {
        let text = $(this).text()
        $(this).text(translateCode(text)) //FIXME: Hard core, double for
    })

    $container.find('.js.color').html(circle)
    handleColorNegation($container)

    return translateCode(formattedCode)
}


// FIXME? - Better way ?
// TODO - Verify :
// - if (!color || color)
// - if (color || !color)
// - while (!color)
// ...
function handleColorNegation ($container) {
    $container.find('.js.color').each(function () {
        let $color = $(this)
        let $prev = $color.prev()
        if ($prev.text() === '(!') {
            $color.addClass('negation')
            $prev.text('')

            let nextText = $color.next().text()
            $color.next().text(nextText.replace(/[()]/g, ''))
        }
    })
}



function translateCode (code) {
    let {translations} = translate
    for (let key in translations) {
        code = code.replace(new RegExp(`\\b${key.toString()}\\b`, 'g'), translate(key))
    }

    return code
}







function resize () {
    if (!currentCode) {
        return
    }

    resizeCode($targetContainer, currentCode)
}



function resizeCode ($container, code) {
    resizeFont($container, code)
    $container.css('top',  0.5 * ($(window).height() - $container.height()) + 'px')
}


let bestLineHeight

function resizeFont ($container, code) {
    setBestLineHeight(code)
    let fontSize   = findBestFontSize($container, code)
    let lineHeight = parseInt($sizeSetter.css('line-height'), 10)
    $container.css('font-size', fontSize + 'px')
    $container.find('.line:not(:last)').css({
        marginBottom: (lineHeight - fontSize) + 'px'
    })
    $container.find('.line').css({
        height: fontSize + 'px'
    })

}



function findBestFontSize ($container, code) {

    let formattedCode = codeFormater.convertColorConditionsForSizeSetter(code)
    $sizeSetter.html(formattedCode)

    let limitedBy = findLimitingDimension($container)

    let startingSize = Math.floor(12 / (1.1 * ratio($container, limitedBy)))
    let endingSize   = Math.ceil(startingSize * 1.5)

    let fontSize
    for (fontSize = startingSize; fontSize < endingSize; fontSize++) {
        resizeSizeSetter(fontSize)
        if (ratio($container, limitedBy) > 1) {
            break
        }
    }

    return fontSize - 1
}


function setBestLineHeight (code) {
    let linesCount = code.split('\n').length
    bestLineHeight = 1.5 - 0.3 * Math.max(0, Math.min(1, (linesCount - 10) / 10))
}



function resizeSizeSetter (fontSize) {
    $sizeSetter.css({
        fontSize:   fontSize + 'px',
        lineHeight: Math.round(fontSize * bestLineHeight) + 'px'
    })
}


function findLimitingDimension ($container) {
    resizeSizeSetter(12)

    if (ratio($container, 'height') > ratio($container, 'width')) {
        return 'height'
    } else {
        return 'width'
    }
}


function ratio ($container, limitedBy) {
    if (limitedBy === 'width') {
        return exactWidthFor($sizeSetter)  / exactWidthFor($container)
    } else {
        return exactHeightFor($sizeSetter) / exactHeightFor($('#mapContainer'))
    }
}


function exactWidthFor ($element) {
    return $element[0].getBoundingClientRect().width
}

function exactHeightFor ($element) {
    return $element[0].getBoundingClientRect().height
}


export default {
    resizeCode
}

